<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
    </div>
    <el-form :model="formData" ref="form">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            果园编号：
            <span>{{parseStrEmpty(formData.plantationBizNo)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            检测日期：
            <span>{{parseStrEmpty(formData.testDate)}}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            果园名称：
            <span>{{parseStrEmpty(formData.plantationName)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            果园区域：
            <span>{{ parseStrEmpty(formData.locName) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            农残:
            <span>{{parseStrEmpty(formData.pesticideTestPassedText)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            重金属：
            <span>{{parseStrEmpty(formData.heavyMetalTestPassedText)}}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <span class="line">
            备注：
            <span>{{parseStrEmpty(formData.remark)}}</span>
          </span>
        </el-col>
      </el-row>
    </el-form>
    <div class="title title-mt title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">检测报告</div>
      </div>
    </div>
    <Attachment
      v-if="formData.attachments && formData.attachments.length > 0"
      :fileList="formData.attachments"
      :is-examine="true"
      :isEdit="false"
      :showFileType="false"
    ></Attachment>
    <div v-else class="no-contract-type">暂无内容</div>

    <div class="title title-mt title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">历史修改记录</div>
      </div>
    </div>
    <TablePublic :colLists="colLists2" :tableData="tableData" :paginationFlag="false">
      <template slot="modificationDesc" slot-scope="scope">
        <el-tooltip :disabled="!scope.data.modificationDesc" :content="scope.data.modificationDesc" placement="top" popper-class="custom-tooltip-width">
          <div class="modificationDesc">{{ scope.data.modificationDesc }}</div>
        </el-tooltip>
        <!-- <el-popover
          placement="right-end"
          width="900"
          trigger="manual"
          v-model="scope.data.visible"
        >
          <div>
            <div class="popover_title">
              <div>果树信息修改详情</div>
              <div class="el-icon-circle-close" @click="scope.data.visible = false"></div>
            </div>
            <TablePublic :colLists="colLists4" :showIndex="false" :tableData="scope.data.lastList" :paginationFlag="false"></TablePublic>
            <TablePublic style="margin-top: 20px;" :colLists="colLists3" :showIndex="false" :tableData="scope.data.beforeList" :paginationFlag="false"></TablePublic>
          </div>``
          <div slot="reference" @click="scope.data.visible = true" style="width: 150px;">
            <span>“果树信息"修改</span>
            <span class="view_button"><详情></span>
          </div>
        </el-popover> -->
      </template>
    </TablePublic>
    <Box :row="formData"></Box>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/statusConstants'
import { mapState } from 'vuex'
import { getCropTestReportDetail, getAmdRecList } from '@/api/system/manage'
import TablePublic from '@/components/tablePublic'
import Attachment from '@/components/attachment.vue'
import Box from '@/components/nameBox.vue'
export default {
  components: {
    TablePublic,
    Attachment,
    Box
  },
  data() {
    return {
      title: '',
      currentView: '',
      dialogVisible: false,
      colLists4: [
        {
          prop: 'code',
          label: '修改后',
          isTrue: true,
          children: [],
        },
      ],
      colLists3: [
        {
          prop: 'code',
          label: '修改前',
          isTrue: true,
          children: [],
        },
      ],
      popoverChildren: [
        {
          prop: 'index',
          label: '序号',
          isTrue: true,
          width: '55'
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
          width: '100'
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄(年)',
          isTrue: true,
          width: '120'
        },
        {
          prop: 'estimatedUnitPrice',
          label: '预售单价(元)',
          isTrue: true,
          width: '120'
        },
        {
          prop: 'occupiedArea',
          label: '亩数',
          isTrue: true,
          width: '100'
        },
        {
          prop: 'estimatedUnitOutput',
          label: '预售亩产量(斤)',
          isTrue: true,
          width: '120'
        },
        {
          prop: 'estimatedTotalOutput',
          label: '预估总产量(斤)',
          isTrue: true,
          width: '120'
        },
        {
          prop: 'code',
          label: '走访单号',
          isTrue: true,
        },
      ],
      colLists2: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          align: 'left',
          formSolt: true,
        },
        {
          prop: 'reason',
          label: '修改原因',
          align: 'left',
          isTrue: true,
        },
        {
          prop: 'createDate',
          label: '修改日期',
          isTrue: true,
          width: '100'
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: '100'
        },
      ],
      colLists: [
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄',
          isTrue: true,
        },
        {
          prop: 'occupiedArea',
          label: '果树亩数',
          isTrue: true,
        },
        {
          prop: 'estimatedTotalOutput',
          label: '预估总产量(斤)',
          isTrue: true,
        },
        {
          prop: 'estimatedUnitPrice',
          label: '预售单价(元)',
          isTrue: true,
        },
      ],
      tableData: [],
      formData: {},
    }
  },
  computed: {
    ...mapState({ 
      dictList: (state) => state.system.dictList || []
    })
  },
  methods: {
    getDetails(row){
      if(row){
        getCropTestReportDetail(row.id).then(res => {
          if (res.flag) {
            this.formData = {
              ...res.data,
              locName: this.formatLocal(res.data.locDetails, 3),
              testDate: this.parseTime(res.data.testDateTime, '{y}-{m}-{d}'),
              pesticideTestPassedText: CONSTANTS.getStatusConversion(res.data.isPesticideTestPassed, 'pesticideTestPassedStatus2'),
              heavyMetalTestPassedText: CONSTANTS.getStatusConversion(res.data.isHeavyMetalTestPassed, 'heavyMetalTestPassedStatus2'),
              attachments: res.data.attachments &&
                res.data.attachments.map((f) => {
                  return {
                    ...f,
                    fileUrl: f.url,
                    fileName: f.name,
                    fileType: f.type,
                    fileSuffix: f.name.substring(f.name.lastIndexOf('.') + 1)
                  } || []
              })
            }
            this.colLists3[0].children = this.popoverChildren
            this.colLists4[0].children = this.popoverChildren
            this.getAmdRecList(row.id)
          }
        })
      }
    },
    getAmdRecList(id){
      getAmdRecList({formId: id, formType: 'crop_test_report'}).then(res => {
        if (res.flag) {
          this.tableData = res.data.map(d=>{
            d.lastList = this.formatCropJsonParse(d.currContent)
            d.beforeList = this.formatCropJsonParse(d.orignalContent)
            d.createDate = this.parseTime(d.createTime, '{y}-{m}-{d}')
            d.visible = false
            return d
          })
        }
      })
    },
    reset(){
      this.tableData.some(item=>item.visible = false)
    },
    cancel() {
      this.dialogVisible = false
    },
    formatCropJsonParse (obj) {
      if(!obj){
        return []
      }
      let cropObj = JSON.parse(obj)
      let cropDetails = []
      if(cropObj.cropDetails && cropObj.cropDetails.length){
        cropDetails = cropObj.cropDetails.map((d, index)=>{
          d.index = index+1
          d.code = cropObj.bizNo
          return d
        })
      }
      return cropDetails
    }
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-form-item {
  margin-bottom: 0px;
}
.err {
  color: red;
  margin-left: 10px;
  font-size: 14px;
}
.topmargin {
  margin-top: 20px;
}
.line {
  display: flex;
  word-break: keep-all;
  padding: 8px 0;
  span{
    word-break: break-all;
  }
}
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-top: 10px;
  }
}
</style>